import type { ComponentProps, PropsWithChildren } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import SolidLockAltIcon from 'LuxKit/Icons/solid/SolidLockAltIcon'
import AspectRatio from 'components/utils/AspectRatio'
import { REBRAND_PALETTE_CLASS } from 'lib/theme/paletteVersion'

const ImageWrapper = styled(AspectRatio)`
  position: relative;
  overflow: hidden;
  aspect-ratio: 3/2;

  body.${REBRAND_PALETTE_CLASS} & {
    border-radius: var(--border-radius-m);
  }
  
  ${mediaQueryUp.tablet} {
    /* Default/fallback size */
    width: ${rem(512)};
    height: ${rem(200)};
    
    &.small {
      width: ${rem(320)};
      height: ${rem(160)};
    }
  }
`

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.3);
  display: grid;
  place-items: center;
  backdrop-filter: blur(12px);

  body.${REBRAND_PALETTE_CLASS} & {
    border-radius: var(--border-radius-m);
    overflow: hidden;
  }
`

interface Props extends PropsWithChildren, Pick<ComponentProps<typeof AspectRatio>, 'ratio' | 'tabletRatio' | 'desktopRatio' | 'largeDesktopRatio'> {
  size?: 'small' | 'medium'
}

const StyledSolidLockAltIcon = styled(SolidLockAltIcon)`
  color: var(--palette-neutral-surface-dark-contrast);
`

function LuxPlusHiddenOfferImageContainer(props: Props) {
  const {
    children,
    size,
    ratio,
    tabletRatio,
    desktopRatio,
    largeDesktopRatio,
  } = props

  return <ImageWrapper className={size} ratio={ratio} tabletRatio={tabletRatio} desktopRatio={desktopRatio} largeDesktopRatio={largeDesktopRatio}>
    {children}
    <Overlay>
      <StyledSolidLockAltIcon size="XL" />
    </Overlay>
  </ImageWrapper>
}

export default LuxPlusHiddenOfferImageContainer
